import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';

import FMPHeadline from '../../components/ui/FMPHeadline';
import BulkDeliveriesContainer from '../../containers/logistics/BulkDeliveries';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import ViewBulkDeliveryLogDialog from '../../components/Dialogs/ViewBulkDeliveryLogDialog';

import {
	statusClassNames,
	formatStatus,
	isFiltered,
	sortTable,
	PureRecordRow,
} from '../../libs/utility';

import {getSharedStyles} from "../../themes";
import NoteIcon from "@material-ui/icons/Note";
const styles = (theme) => ({
	...statusClassNames,
	...getSharedStyles(theme),

	row : {
		cursor : 'pointer',
	},
	button: {
		verticalAlign : 'middle',
		padding : '8px 10px',
	},
	stats : {
		padding : '20px 10px 20px 10px',
		borderBottom : '1px solid #ddd',
		marginBottom : 10,
	},
	statGroup : {
		padding : '5px 5px 10px 5px',
		borderBottom : '1px solid #eee',
		marginBottom : 10,
	},
	available : {
		fontWeight : 900,
	},
	popOverPaper : {
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
	},
	commentsContainer : {
		padding : 7,
		display: 'inline-block',
		fontSize : '90%',
	},
	commentDateTime : {
		fontSize : '80%',
		color : '#666',
	},
	popover: {
		pointerEvents: 'none',
	},
});

//const columnStyle = { whiteSpace : 'nowrap' };
const columnData = [{
	id: 'bulkDeliveryId',
	label: 'Bulk ID',
	padding : 'checkbox',
}, {
	id: 'pickupDisplay',
	label: 'Pickup',
	padding : 'dense',
}, {
	id: 'offloadDisplay',
	label: 'Offload',
	padding : 'checkbox',
}, {
	id: 'carrierDisplay',
	label: 'Carrier',
	padding : 'checkbox',
}, {
	id: 'deliveryDate',
	label: 'Date',
	padding : 'checkbox',
}, {
	id: 'status',
	label: 'Status',
	padding : 'checkbox',
}, {
	id: 'internalNote',
	numeric: false,
	padding : 'checkbox',
	label: 'Internal Note',
}, {
	id: 'edit',
	padding : 'checkbox',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}];

class BulkDeliveries extends Component {
	constructor(props){
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'bulkDeliveryId',
			search : '',
			isViewDialogOpen : false,
			viewBulkDelivery : undefined,
			commentPopoverAnchor : undefined,
			popoverComment : '',
		};
	}

	componentDidMount () {
		if (!this.props.bulkDeliveries.length) {
			this.props.searchBulkDeliveries();
		}
	}

	handleSearch = (event) => {
		this.setState({ search : event.target.value });
	};

	handleRequestSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleEdit = (bulkDeliveryId) => {
		this.props.history.push(`/logistics/bulkDelivery/update/${bulkDeliveryId}`);
	};

	handleRowClick = (bulkDeliveryId) => {
		const { bulkDeliveries } = this.props;
		const viewBulkDelivery = _.find(bulkDeliveries, { bulkDeliveryId });

		this.setState({
			viewBulkDelivery,
			isViewDialogOpen : true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen : false,
			viewBulkDelivery : undefined
		});
	};

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor : event.currentTarget
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor : null });
	};

	render() {
		const {
			classes,
			bulkDeliveries,
			canMakeUpdates,
			carrierMap,
			terminalMap,
			supplierMap,
			bulkCustomerMap,
		} = this.props;

		const { order, orderBy, search} = this.state;

		if (!bulkDeliveries) {
			return (<div>Loading the bulk deliveries...</div>);
		}
		let rows = bulkDeliveries.reduce((result, bulkDelivery) => {
			const {
				bulkDeliveryId,
				deliveryTerminalId,
				deliveryBulkCustomerId,
				pickupTerminalId,
				pickupSupplierId,
				deliveryDate,
				//loadingNumber,
				carrierId,
				status,
				internalNote,
			} = bulkDelivery;

			if (status === 'needsActivation') {
				return result;
			}

			const pickupTerminal = terminalMap[pickupTerminalId];
			const pickupTerminalDisplay = (pickupTerminal)
				? pickupTerminal.name
				: 'Missing Terminal';

			const pickupSupplier = supplierMap[pickupSupplierId];
			const pickupSupplierDisplay = (pickupSupplier)
				? pickupSupplier.name
				: 'Missing Supplier';

			const pickupDisplay = (<div>
				<div>{pickupTerminalDisplay}</div>
				<div>{pickupSupplierDisplay}</div>
			</div>);


			const deliveryTerminal = terminalMap[deliveryTerminalId];
			const deliveryTerminalDisplay = (deliveryTerminal)
				? deliveryTerminal.name
				: 'Missing Terminal';

			const deliveryBulkCustomer = bulkCustomerMap[deliveryBulkCustomerId];
			const deliveryBulkCustomerDisplay = (deliveryBulkCustomer)
				? deliveryBulkCustomer.name
				: 'Missing Bulk Customer';


			const offloadDisplay = (<div>
				<div>{deliveryTerminalDisplay}</div>
				<div>{deliveryBulkCustomerDisplay}</div>
			</div>);


			const carrier = carrierMap[carrierId];
			const carrierDisplay = (carrier)
				? carrier.name
				: 'Missing Carrier';

			const deliveryDateFormatted = moment(deliveryDate)
				.format('ddd M/D');

			const {statusClassName, statusDisplay} = formatStatus(status);

			let commentDisplay;
			if (!internalNote) {
				commentDisplay = (<div>-</div>);
			} else {
				commentDisplay = (
					<div
						style={{display : 'inline-block', color : '#2196f3' }}
						onMouseEnter={(event) => {
							this.handleCommentPopoverOpen(event, internalNote);
						}}
						onMouseLeave={this.handleCommentPopoverClose}
					>
						<NoteIcon />
					</div>
				);
			}

			const row = {
				bulkDeliveryId,
				carrierId,
				pickupDisplay,
				offloadDisplay,
				carrierDisplay,
				statusDisplay,
				deliveryDateFormatted,
				deliveryDate,
				statusClassName,
				//- for filtering
				pickupTerminalDisplay,
				pickupSupplierDisplay,
				deliveryTerminalDisplay,
				deliveryBulkCustomerDisplay,
				internalNote,
				commentDisplay,
				rowClick : () => { this.handleRowClick(bulkDeliveryId); }
			};

			if (isFiltered({search, data : row,
				fields : [
					'bulkDeliveryId', 'pickupTerminalDisplay', 'pickupSupplierDisplay',
					'deliveryTerminalDisplay', 'deliveryBulkCustomerDisplay', 'carrierDisplay',
				]
			})) {
				return result;
			}
			result.push(row);
			return result;
		}, []);


		rows = sortTable({ data : rows, order, orderBy});

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Bulk Deliveries"
						value={this.state.search}
						onChange={this.handleSearch}
						url="/logistics/bulkDelivery/add"
						buttonText="ADD BULK DELIVERY"
						canMakeUpdates={canMakeUpdates}
					/>

					<Paper className={classes.paper}>
						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columnData}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{rows.map(row => {
									return (
										<PureRecordRow
											hover
											className={classes.row}
											key={row.bulkDeliveryId}
										>
											<TableCell onClick={row.rowClick}>
												{row.bulkDeliveryId}
											</TableCell>
											<TableCell onClick={row.rowClick}>
												{row.pickupDisplay}
											</TableCell>
											<TableCell onClick={row.rowClick}>
												{row.offloadDisplay}
											</TableCell>
											<TableCell onClick={row.rowClick}>
												{row.carrierDisplay}
											</TableCell>

											<TableCell onClick={row.rowClick}>
												{row.deliveryDateFormatted}
											</TableCell>

											<TableCell
												onClick={row.rowClick}
												className={classes[row.statusClassName]}
												style={{whiteSpace:'nowrap'}}
											>
												{row.statusDisplay}
											</TableCell>

											<TableCell>
												{row.commentDisplay}
											</TableCell>

											{canMakeUpdates &&
											<TableCell
												style={{whiteSpace:'nowrap'}}
											>
												<Button
													className={classes.button}
													onClick={() => this.handleEdit(row.bulkDeliveryId)}
												>
													Edit
												</Button>
											</TableCell>
											}

										</PureRecordRow>
									);
								})}
							</TableBody>
						</Table>

						<ViewBulkDeliveryLogDialog
							open={this.state.isViewDialogOpen}
							onClose={this.handleCloseViewDialog}
							bulkDelivery={this.state.viewBulkDelivery}
							history={this.props.history}
						/>

						<Popover
							id="comment-popover"
							className={classes.popover}
							classes={{ paper: classes.popOverPaper}}
							open={!!this.state.commentPopoverAnchor}
							anchorEl={this.state.commentPopoverAnchor}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							onClose={this.state.handleCommentPopoverClose}
							disableRestoreFocus
						>
							<div className={classes.commentsContainer}>
								{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
							</div>
						</Popover>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}


BulkDeliveries.propTypes = {
	classes: PropTypes.object.isRequired,
	searchBulkDeliveries: PropTypes.func.isRequired,
	searchBulkDeliveryLogs : PropTypes.object,
	bulkDeliveries : PropTypes.array,

	showErrors : PropTypes.func.isRequired,

	supplierMap : PropTypes.object,
	carrierMap : PropTypes.object,
	terminalMap : PropTypes.object,
	bulkCustomerMap : PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history : PropTypes.object,

	canMakeUpdates : PropTypes.bool,
};

export default _.flow([
	withStyles(styles),
	BulkDeliveriesContainer
])(BulkDeliveries);
